export const env = {
  version: import.meta.env.VITE_APP_VERSION,
  api_url: (import.meta.env.VITE_APP_DEV_API_URL ?? import.meta.env.VITE_APP_API_URL) as string,
  engine_url: import.meta.env.VITE_APP_MOTEUR_API_URL as string,
  app_url: import.meta.env.VITE_APP_URL as string,
  app_token_url: import.meta.env.VITE_APP_API_TOKEN_URL as string,
  thermodim_logo: import.meta.env.VITE_THERMODIM_LOGO as string,
};
